import { render, staticRenderFns } from "./CardResults.vue?vue&type=template&id=16a23a09&scoped=true"
import script from "./CardResults.vue?vue&type=script&lang=js"
export * from "./CardResults.vue?vue&type=script&lang=js"
import style0 from "./CardResults.vue?vue&type=style&index=0&id=16a23a09&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a23a09",
  null
  
)

export default component.exports